// src/components/result-page/search-tab/subcomponents/dashboard-tab-view/dashboard-widgets/dashboard-exchange-community-widget.tsx

import { h, type FunctionalComponent } from '@stencil/core';
import type { IDashboardDesktopView } from '../dashboard-views/dashboard-desktop-view';

type DashboardExchangeCommunityWidgetProps = Pick<IDashboardDesktopView, 'query' | 'country' | 'language' | 'analyticsTabName' | 'isExchangeVisible' | 'strategies'>;

export const DashboardExchangeCommunityWidget: FunctionalComponent<DashboardExchangeCommunityWidgetProps> = (props) => {
    const {
      query,
      country,
      language,
      analyticsTabName,
      isExchangeVisible,
      strategies
    } = props;

    return (
      isExchangeVisible && <div class="exchange-container widget-offset-bottom">
        <uiaas-search-widget-exchange-community
          //@ts-ignore
          termAttribute={query} //DRUTY - pole jest `term` a nie `termAttribute` coś tu jest nie tak
          country={country}
          language={language}
          threshold={4}
          is-dashboard-view="true"
          screen="desktop"
          analytics-tab-name={analyticsTabName}
          strategies={strategies}
        />
      </div>
    );
};
